import React, { useState } from 'react';
import './MatchCard.css';
import type { MatchDetail } from '@iziping/common';
import MatchToolBar from './MatchToolBar';
import MatchTooltip from '../matches/MatchTooltip';
import { computeMatchColor, formatMatch } from '@iziping/common';
import { Check } from 'lucide-react';

interface MatchCardProps {
    match: MatchDetail;
    isSelected?: boolean;
    onToggle?: (id: number) => void;
}

const MatchCardDetail: React.FC<MatchCardProps> = ({ match, isSelected, onToggle }) => {
    const [showText, setShowText] = useState(false);

    return (
        <div className={`match-card${isSelected ? ' match-card-selected' : ''}`}>
            {onToggle && (
                <button
                    className={`match-card-checkbox${isSelected ? ' match-card-checkbox-checked' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggle(match.id);
                    }}
                    aria-label={isSelected ? 'Désélectionner' : 'Sélectionner'}
                    aria-pressed={isSelected}
                >
                    {isSelected && <Check size={12} strokeWidth={3} />}
                </button>
            )}
            <div className={`match-card-title ${computeMatchColor(match)}`}>
                {match?.table ? `Table ${match?.table.number}` : ''}
                <MatchToolBar match={match} />
            </div>
            <div
                className={'match-content'}
                onMouseEnter={() => setShowText(true)}
                onMouseLeave={() => setShowText(false)}
            >
                <p>{formatMatch(match)}</p>

                {showText && <MatchTooltip match={match} />}
            </div>
        </div>
    );
};

export default MatchCardDetail;
